const forms = document.querySelectorAll('.m-form:not(.m-form--gravityform)');

if ( forms ) {
    forms.forEach( function(form) {
        form.addEventListener( 'submit', function() {
            form.querySelector('button[type="submit"]').classList.add('loading');
            form.querySelector('button[type="submit"]').disabled = true;
        });
    } );
}